// Import constants
import { ErrorShowType, l } from 'constants/common';

const customerJourneyReportValidationScenario = () => ({
    Name: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CannotBeEmpty,
                ParametersValues: null,
            },
            {
                ValidationType: 'firstSymbol',
                ErrorMessage: l.NameFirstCharacterCantBeASymbol,
                ParametersValues: /^[\p{L}0-9]/gu,
            },
            {
                ValidationType: 'minLength',
                ErrorMessage: l.MustContainMinimumCharacters,
                ParametersValues: '3',
            },
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '50',
            },
        ],
    },
    Description: {
        isValid: null,
        errorText: '',
        value: '',
        paramValue: '',
        type: ErrorShowType.Default,
        validationCredentials: [
            {
                ValidationType: 'maxLength',
                ErrorMessage: l.MustContainMaximumCharacters,
                ParametersValues: '250',
            },
        ],
    },
    CJId: {
        isValid: null,
        value: '',
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseSelectCustomerJourney,
                ParametersValues: null,
            },
        ],
    },
    Filter: {
        isValid: null,
        value: '',
        type: ErrorShowType.Toaster,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseSelectValidFilter,
                ParametersValues: 'false',
            },
        ],
    },
    CJStatus: {
        isValid: null,
        value: null,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.CustomerJourneyIsInvalid,
                ParametersValues: null,
            },
        ],
    },
    CJBlock: {
        isValid: null,
        value: null,
        type: ErrorShowType.Default,
        errorText: '',
        paramValue: '',
        validationCredentials: [
            {
                ValidationType: 'required',
                ErrorMessage: l.PleaseSelectBlock,
                ParametersValues: null,
            },
        ],
    },
});

export { customerJourneyReportValidationScenario };
